@if (!modelDefinition.hideInputSearch) {
  <mat-form-field>
    <input matInput #input placeholder="Recherche globale" />
  </mat-form-field>
}
<div
  class="mat-elevation-z8"
  [ngStyle]="{
    'border-top': modelDefinition.list?.border,

    'border-bottom': modelDefinition.list?.border,
    'border-left': modelDefinition.list?.border,
    'border-right': modelDefinition.list?.border,
    'margin-bottom': modelDefinition.list?.border ? '10px' : null
  }"
  >
  <div
    class="table-container"
    [style.max-height]="modelDefinition.list?.maxHeight ?? null"
    >
    <table
      #assistTable
      mat-table
      [dataSource]="instances"
      matSort
      multiTemplateDataRows
      >
      <!-- open detail button-->
      @if (this.modelDefinition.children) {
        <ng-container
          matColumnDef="openChildren"
          >
          <th mat-header-cell *matHeaderCellDef class="open-child-th"></th>
          <td mat-cell *matCellDef="let row" class="open-child">
            <button
              mat-icon-button
              aria-label="Voir détail"
            (click)="
              expandedElement =
                expandedElement === row ? null : manageExpandedRow(row)
            "
              >
              <mat-icon>
                {{
                expandedElement === row ? "expand_less" : "expand_more"
                }}</mat-icon
                >
              </button>
            </td>
          </ng-container>
        }
        <!-- Headers Supplémentaires Column -->
        @for (header of tableHeaders; track header; let indexHeader = $index) {
          @for (column of header.cols; track column; let indexCol = $index) {
            <ng-container
              [matColumnDef]="'col-' + indexCol + '-header-' + indexHeader"
              >
              <th
                mat-header-cell
                *matHeaderCellDef
                [attr.colspan]="column.span ?? displayedColumnNames?.length"
            [ngStyle]="{
              'background-color': column.backgroundColor,
              color: column.color ?? 'rgba(0, 0, 0, 0.87)'
            }"
                [style.text-align]="'center'"
                >
                {{ column.label }}
              </th>
            </ng-container>
          }
        }

        <!-- Footer column if no record -->
        <ng-container matColumnDef="norecord">
          <td
            mat-footer-cell
            *matFooterCellDef
            [colSpan]="displayedColumnNames?.length"
            >
            {{ "No Record" }}
          </td>
        </ng-container>
        <!--Définition des céllules-->
        @for (column of displayedColumns; track column) {
          <ng-container
            [matColumnDef]="column.name"
            >
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              resizable
          [style.color]="
            modelDefinition.list?.header?.color
              ? modelDefinition.list?.header?.color
              : 'rgba(0, 0, 0, 0.87)'
          "
              [style.background-color]="column.headerBackgroundColor"
              >
              {{ column.label }}
            </th>
            <td mat-cell *matCellDef="let instance; let rowIndex = dataIndex">
              @if (
                (column.hyperLinkToDetail &&
                instance.SequenceValue !== currentSequence) ||
                column.hyperLink) {
                <button
                  mat-flat-button
                  class="button-link"
            (click)="
              clickToLink(
                instance,
                column,
                '/' + modelDefinition.name + '/' + instance.id,
                rowIndex
              )
            "
                  >
                  {{ display(column, instance[column.name]) }}
                </button>
              } @else {
                @switch (column.type) {
                  @case ('boolean') {
                    <mat-checkbox
                      [checked]="instance[column.name]"
                      [disabled]="true"
                      >
                    </mat-checkbox>
                  }
                  @case ('image') {
                    <img class="rowimage" [src]="getImage(instance[column.name])" />
                  }
                  @default {
                    @switch (column.typeInList) {
                      @case ('button') {
                        <button
                          mat-flat-button
                          [style.color]="column.color"
                          [style.backgroundColor]="column.backgroundColor"
                          (click)="buttonClick(column.click, instance)"
                          >
                          {{ column.buttonLabel }}
                        </button>
                      }
                      @default {
                        {{ display(column, instance[column.name]) }}
                      }
                    }
                  }
                }
              }
            </td>
          </ng-container>
        }

        <!-- definition des colonnes pour détail-->
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumnNames.length"
            >
            <div
              class="example-element-detail"
              [style.width]="modelDefinition.childrenWidth"
            [@detailExpand]="
              element == expandedElement ? 'expanded' : 'collapsed'
            "
              >
              @for (child of modelDefinition.children; track child) {
                @if (childrenModels.get(child.name) | async; as childModel) {
                  <ng-container>
                    @if (child.accordion) {
                      <mat-accordion
                        class="example-headers-align"
                        multi
                        >
                        <mat-expansion-panel
                      (opened)="
                        childrenLoaded.set(
                          child.name + element.SequenceValue,
                          true
                        )
                      "
                          [style.background-color]="child.backgroundColor"
                          [style.border]="child.borderStyle"
                          >
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              {{ child.panelTitle }}
                            </mat-panel-title>
                            <mat-panel-description>
                              {{ child.description }}
                              <mat-icon>{{ child.icon }}</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <ng-container
                            *ngTemplateOutlet="childTemplate"
                          ></ng-container>
                        </mat-expansion-panel>
                      </mat-accordion>
                    } @else {
                      @if (
                        childrenLoaded.get(child.name + element.SequenceValue)
                        ) {
                        @if (child.type === 'LIST') {
                          <agil-mat-table-list
                            [modelDefinition]="childModel"
                            [hideOpenButton]="childModel.hideOpenButton"
                            [queryFilters]="child.queryFilters"
                        [masterQueryFilters]="
                          child.sendMasterQueryFilters
                            ? query?.queryFilters
                            : null
                        "
                            [inputPageSize]="5"
                            [allowMultiSelect]="true"
                            [parentRow]="element"
                            >''
                          </agil-mat-table-list>
                        }
                      }
                    }
                    <ng-template #childTemplate>
                      @if (
                        childrenLoaded.get(child.name + element.SequenceValue)
                        ) {
                        @if (child.type === 'LIST') {
                          <agil-mat-table-list
                            [modelDefinition]="childModel"
                            [hideOpenButton]="childModel.hideOpenButton"
                            [queryFilters]="child.queryFilters"
                        [masterQueryFilters]="
                          child.sendMasterQueryFilters
                            ? query?.queryFilters
                            : null
                        "
                            [inputPageSize]="5"
                            [allowMultiSelect]="true"
                            [parentRow]="element"
                            >''
                          </agil-mat-table-list>
                        }
                      }
                    </ng-template>
                  </ng-container>
                }
              }
            </div>
          </td>
        </ng-container>
        <!-- Headers Supplémentaires -->
        @for (header of tableHeaders; track header; let indexHeader = $index) {
          <tr
            mat-header-row
            *matHeaderRowDef="templateColsName.get(indexHeader); sticky: true"
          [ngStyle]="{
            'background-color': header.backgroundColor
          }"
          ></tr>
        }
        <!-- Header de base avec les titres des colonnes -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnNames; sticky: true"
        [ngStyle]="{
          'background-color':
            modelDefinition.list?.headerBackgroundColor ?? '#eaeafc'
        }"
        ></tr>
        <!-- instance rows -->
        <tr
          mat-row
          #matrowFocusable
          *matRowDef="let row; columns: displayedColumnNames; dataIndex as index"
          class="example-element-row"
          (mouseover)="hover[index] = true"
          (mouseleave)="hover[index] = false"
        [ngStyle]="
          row.SequenceValue === currentSequence
            ? { background: 'antiquewhite' }
            : modelDefinition.list?.rowBackgroundColor
            ? modelDefinition.list?.rowBackgroundColor && !hover[index]
              ? {
                  background: modelDefinition.list?.rowBackgroundColor
                }
              : modelDefinition.list?.rowBackgroundColorHover && hover[index]
              ? {
                  background: modelDefinition.list?.rowBackgroundColorHover
                }
              : modelDefinition.list?.rowBackgroundColor && hover[index]
              ? {
                  background: 'whitesmoke'
                }
              : null
            : null
        "
    >
    >
  </tr>
  <!-- row expanded details -->
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
  <!--footer row-->
  <tr
    mat-footer-row
    *matFooterRowDef="['norecord']"
    [hidden]="instances?.totalItems"
  ></tr>
</table>
</div>
<mat-paginator
  [length]="instances?.totalItems"
  [pageSize]="instances?.pageSize > pageSize ? instances?.pageSize : pageSize"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
  [hidden]="modelDefinition.list?.hidePaginator"
    [ngStyle]="{
      'border-top': modelDefinition.list?.border,
      'border-top-width': modelDefinition.list?.border ? '1px' : null
    }"
  >
</mat-paginator>
</div>
@if (instances?.loading$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
